module.exports = __webpack_public_path__ + "static/media/call-for-papers.7f38824d.mp4";